/**
 * ***************************
 * Approval Dashboard Components in Discovery Tool *
 * ***************************
 */
const ApprovalDashboardMain = () =>
  import('@/components/ApprovalDashboard/ApprovalDashboardMain');
const ApprovalDashboardDataTable = () =>
  import('@/components/ApprovalDashboard/ApprovalDashboardDataTable');

export default {
  title: 'Approval Dashboard',
  link: '/discovery/approval-dashboard',
  path: 'approval-dashboard',
  redirect: '/discovery/approval-dashboard/for-approval',
  component: ApprovalDashboardMain,
  permission: [
    {
      action: 'view',
      entity: 'discovery_project_approval_dashboard'
    }
  ],
  meta: {
    id: 'discovery__approval-dashboard-tab'
  },
  children: [
    {
      path: 'for-approval',
      component: ApprovalDashboardDataTable,
      meta: {
        permission: [
          {
            action: 'view',
            entity: 'discovery_project_approval_dashboard'
          }
        ],
        id: 'discovery__for-approval-tab'
      },
      props: { typeOfTable: 'WAITING_FOR_APPROVAL', name: 'approval' }
    },
    {
      path: 'rejected',
      component: ApprovalDashboardDataTable,
      props: { typeOfTable: 'REJECTED', name: 'rejected' },
      meta: {
        permission: [
          {
            action: 'view',
            entity: 'discovery_project_approval_dashboard'
          }
        ],
        id: 'discovery__rejected-tab'
      }
    },
    {
      path: 'approved',
      component: ApprovalDashboardDataTable,
      props: { typeOfTable: 'ACTIVE-ARCHIVED', name: 'active' },
      meta: {
        permission: [
          {
            action: 'view',
            entity: 'discovery_project_approval_dashboard'
          }
        ],
        id: 'discovery__approved-tab'
      }
    },
    {
      path: 'edit-requested',
      component: ApprovalDashboardDataTable,
      props: {
        typeOfTable: 'REQUEST_FOR_EDIT',
        name: 'requestForEdit'
      },
      meta: {
        permission: [
          {
            action: 'view',
            entity: 'discovery_project_approval_dashboard'
          }
        ],
        id: 'discovery__edit-requested-tab'
      }
    }
  ]
};
